/**
 * Created by Ivan on 19.10.2026
 */

Mission.TYPE_DISCO_PARTY = 108;

Mission.REGISTRATIONS.set(Mission.TYPE_DISCO_PARTY, () => ({
    available: cleverapps.config.availables.DISCO_PARTY_MISSION,
    name: "DiscoParty",
    logic: DiscoParty,
    view: DiscoPartyWindow,
    startWindow: DiscoPartyWindow,
    slots: DiscoParty.GetSlots(),
    schedule: "SAT-TUE",
    semaphore: Mission.SEMAPHORE_ALWAYS,
    needsPayments: true,
    abTest: () => cleverapps.abExperiments.getGroup(ABExperiments.Tests.discoparty) === "A",
    canStart: DiscoParty.CanStart,
    bundle: "discoparty",
    guideWindow: {
        name: "DiscoPartyRulesWindow",
        bundle: bundles.discoparty,
        title: "Missions.DiscoParty.Title",
        stagesContent: function () {
            return ["discoparty_reward_bg", "discoparty_elf", "discoparty_checkmark"].map((frame) => new cc.Sprite(bundles.discoparty.frames[frame]));
        }
    },
    sideBarJson: bundles.sidebar.jsons.discoparty_icon_json
}));

cleverapps.InitByFeature["discoparty"] = function () {
    cleverapps.tutorial.register(DiscoPartyTutorial());
};
